/**
 * If the number is greater than a million, return the number divided by a million, rounded down, with
 * a "M+" appended. If the number is greater than a thousand, return the number divided by a thousand,
 * rounded down, with a "K+" appended. Otherwise, return the number.
 * @param number - The number to be formatted.
 * @returns A string.
 */
export function compactFormat(number) {
  const aMillion = 1000000;
  const aThousand = 1000;

  if (number === undefined) {
    return ``;
  }

  if (Number.isNaN(number)) {
    return `${number}`;
  }

  if (number >= aMillion) {
    return `${Math.floor(number / aMillion)}M+`;
  }

  if (number >= aThousand) {
    return `${Math.floor(number / aThousand)}K+`;
  }

  return `${number}`;
}
